import { Optional } from '@angular/core';

export abstract class AtxBehaviorSubjectService<T> {
    constructor(@Optional() private readonly _model) {}

    public setModel(model: T) {
        this._model.data = model;
    }

    public getModel() {
        return this._model.subject();
    }

    public externalSubscribe(service: string, callback: Function) {
        return this[ service ].subscribe(callback);
    }

    public getValue() {
        return this._model.data;
    }

    public subscribe(callback) {
        const observe$ = this._model.subject();

        return observe$.subscribe(callback);
    }
}
